import { useState } from "react";
import CaseRichTextEditor from "../../Components/Common/Editor/CaseRichTextEditor";

// ===============================
// EDITOR HOOK
// ===============================
export const useRichTextEditor = () => {
  const [editorState, setEditorState] = useState("");

  const clearEditor = () => setEditorState("");

  const loadHtmlToEditor = (html) => {
    if (!html) {
      setEditorState("");
      return;
    }

    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(html);

    let formattedHtml = String(html);

    if (!hasHtmlTags) {
      formattedHtml = html
        .replace(/\r\n/g, "\n")
        .split("\n")
        .map((line) => `<p>${line || "<br/>"}</p>`)
        .join("");
    }

    setEditorState(formattedHtml);
  };

  const getHtmlFromEditor = () => editorState || "";

  const onEditorChange = (state) => setEditorState(state || "");

  return {
    editorState,
    onEditorChange,
    clearEditor,
    loadHtmlToEditor,
    getHtmlFromEditor,
  };
};

// ===============================
// EDITOR COMPONENT
// ===============================
export const RichTextEditor = ({ editorState, onEditorChange, onBlur }) => {
  return (
    <CaseRichTextEditor
      editorState={editorState}
      onEditorStateChange={onEditorChange}
      onBlur={onBlur}
    />
  );
};
